module.exports = __webpack_public_path__ + "img/icon_WaterSign_leisure.ee13fcdc.png";